import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MyOrdersFilterAnalyticsService {
  static deliveryDate(filters): string {
    let deliveryDate: string;
    if (
      filters &&
      filters.deliveryDate &&
      filters.deliveryDate.start &&
      filters.deliveryDate.end
    ) {
      deliveryDate = `${filters.deliveryDate.start}-${filters.deliveryDate.end}`;
    }
    return deliveryDate;
  }

  static distinctCustomerIds(filters): string {
    let customers = new Map();
    for (const c in filters.customers) {
      if (typeof filters.customers[c] === 'boolean') {
        if (filters.customers[c]) {
          customers.set(c, c);
        }
      } else {
        for (const d in filters.customers[c]) {
          if (filters.customers[c][d]) {
            customers.set(c, c);
          }
        }
      }
    }
    return [...customers.values()].join(',');
  }

  static orderStatuses(filters): string {
    let orderStatuses: string[] = [];
    for (const os in filters.orderStatus) {
      if (filters.orderStatus[os]) {
        orderStatuses.push(MyOrdersFilterAnalyticsService.snakeToCamel(os));
      }
    }
    return orderStatuses.join(',');
  }

  static snakeToCamel(snake: string): string {
    return snake
      .toLowerCase()
      .replace(/([_][a-z])/g, group => group.toUpperCase().replace('_', ''));
  }
}
